/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import React, { Component } from 'react'

import waitingRobot from '../../../assets/img/tracebot_sorry.svg'

import './ErrorSection.css'

/*
 * Props
 *
 * backPressed
 * log
 */

export default class ErrorSection extends Component {

    constructor() {
        super()
        this.backPressed = this.backPressed.bind(this)
    }

    backPressed() {
    }

    render() {
        var styles = {}
        if (this.props.show === false) {
            styles = { display: 'none' }
        }

        return (
            <div className="ErrorSection" style={styles}>
                <h2>We&apos;re sorry, but we could not finish processing your game.</h2>
                <p>Something happend that we need to look into. The Trace team has been notified and will be taking action to fix the problem as soon as possible.</p>
                <img alt="waiting" className="waiting-robot" src={waitingRobot} />
                <div className="buttons">
                    <button className="trace-input" onClick={this.props.onUnderstand}>OK, I Understand</button>
                </div>
            </div>
        )
    }
}
